
const useDemandStudioLayout = ({
  useStudioState,
  previewSelectorsInHeader = false,
}) => {
  const studioState = useStudioState();

  const shouldShowHeaderSelectors = previewSelectorsInHeader && studioState.showPreview;
  const shouldHideBodySelectors = previewSelectorsInHeader;

  return {
    studioState,
    shouldShowHeaderSelectors,
    shouldHideBodySelectors,
  };
};

export default useDemandStudioLayout;
